import { render, staticRenderFns } from "./Action_landing.vue?vue&type=template&id=18e1ce6f&lang=pug&"
import script from "./Action_landing.vue?vue&type=script&lang=js&"
export * from "./Action_landing.vue?vue&type=script&lang=js&"
import style0 from "./Action_landing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports